import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';


const Sidebar = ({isMenuCollapsed}) => {

    const location = useLocation();
    const currentPath = location.pathname;

    const isActive = (path) => currentPath === path ? 'active' : '';


    return (
        < >

            <div class="flapt-sidemenu-wrapper">

                <div class="flapt-logo">
                    <a href="/">
                        <img class="desktop-logo" style={{ maxHeight: 65, marginTop: '6px' }} src="/admin_codebase/img/core-img/b-logo1.png" alt="Desktop Logo" />
                        <img class="small-logo" src="/admin_codebase/img/core-img/small-logo.png" alt="Mobile Logo" /></a>
                </div>
                <br />

                <div class="flapt-sidenav" id="flaptSideNav">

                    <div class="side-menu-area sidebar-scrollable">

                        <nav>
                            <ul class="sidebar-menu" data-widget="tree">
                                <br />

                                <li className={isActive('/customer/dashboard')}>
                                    <Link to="/customer/dashboard"><i
                                        class='bx bx-home-heart'></i>{!isMenuCollapsed && <span>Dashboard</span>}
                                    </Link>
                                </li>
                                <li className={isActive('/customer/document_upload')}>
                                    <Link to="/customer/document_upload">
                                        <i class='bx bx-file'></i>{!isMenuCollapsed && <span>Document</span>}
                                    </Link>
                                </li>
                                <li className={isActive('/customer/chat')}>
                                    <Link to="/customer/chat"><i
                                        class='bx bx-message-rounded-dots'></i>{!isMenuCollapsed && <span>Chat</span>}
                                    </Link>
                                </li>

                                <li className={isActive('/customer/script_generation')}>
                                    <Link to="/customer/script_generation">
                                        <i class='bx bx-code-alt'></i>{!isMenuCollapsed && <span>Script Generation</span>}
                                    </Link>
                                </li>
                                <li className={isActive('/customer/lead')}>
                                    <Link to="/customer/lead">
                                       <i class='bx bx-list-ul'></i>{!isMenuCollapsed && <span>Lead List</span>}
                                    </Link>
                                </li>
                                 <li className={isActive('/customer/meeting')}>
                                    <Link to="/customer/meeting">
                                        <i class='bx bx-calendar'></i>{!isMenuCollapsed && <span>Meeting List</span>}
                                    </Link>
                                </li>

                                <li className={isActive('/customer/support')}>
                                    <Link to="/customer/support">
                                        <i class='bx bx-support'></i>{!isMenuCollapsed && <span>Support</span>}
                                    </Link>
                                </li>



                                {/* <li class="menu-header-title">Settings</li> */}
                                {/* <li className={isActive('/customer/settings')}>
                                    <Link to="/customer/settings"><i class='bx bx-book'></i>{!isMenuCollapsed && <span>Master Settings</span>}</Link>
                                </li> */}
                                {/* <li className={isActive('/customer/settings')}>
                                    <Link to="/customer/settings"><i class='bx bx-wrench'></i>{!isMenuCollapsed && <span>Master Settings</span>}</Link>
                                </li> */}

                                <li className={isActive('/customer/logout')}>
                                    <Link to="/customer/logout"><i class='bx bx-log-out-circle'></i>{!isMenuCollapsed && <span>Logout</span>}</Link>
                                </li>





                                {/* <li class="treeview"><Link to="/shop"><i class="bx bxs-cart"></i>Shop<i class="fa fa-angle-right"></i></Link>

                                    <ul class="treeview-menu">
                                        <li><Link to="/coins">Coins</Link></li>
                                        <li><Link to="/shopmodels">Shop models</Link></li>
                                    </ul>
                                </li> */}

                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />




                            </ul>
                        </nav>
                    </div>
                </div>
            </div >

        </>
    );
};

export default Sidebar;

